import { CommonModule } from "@angular/common";
import { Component, input } from "@angular/core";
import { Icon } from "@malirang/front-share";

@Component({
    selector: "app-pin",
    templateUrl: "./pin.component.html",
    imports: [Icon, CommonModule],
})
export class PinComponent {
    isPinned = input<boolean>(false);

    /**
     * 데이터 그리드 대응
     */
    row = input<any>();
}
